/** 
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Program services
  Date: may 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();
import { globalPageLimit } from '../constants/applicationConstants';

export const getProgramList = (payload) => {
  const queryString = (payload) ? `${payload}&limit=${globalPageLimit.PROGRAM_LIMIT}` : `limit=${globalPageLimit.PROGRAM_LIMIT}`;
  return API.get(`programs/programs?${queryString}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};